var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wrapper" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col col-12 col-md-3 name" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("c-input", {
              attrs: {
                "floating-label": "Организация",
                clearable: true,
                "max-length": 255,
                required: _vm.error && _vm.error.company,
                "required-message": _vm.error && _vm.error.company,
              },
              model: {
                value: _vm.value.company,
                callback: function ($$v) {
                  _vm.$set(_vm.value, "company", $$v)
                },
                expression: "value.company",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "col col-12 col-md-3 position" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("c-select", {
              attrs: {
                type: "select",
                "floating-label": "Должность",
                clearable: true,
                items: _vm.options,
                invalid: _vm.error && !!_vm.error.position,
                error: _vm.error && _vm.error.position,
                "custom-options": _vm.field.custom,
              },
              model: {
                value: _vm.value.position,
                callback: function ($$v) {
                  _vm.$set(_vm.value, "position", $$v)
                },
                expression: "value.position",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "col col-6 col-md-2 salary" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("c-input", {
              attrs: {
                "floating-label": "Размер зарплаты, ฿",
                clearable: true,
                type: "price-number",
                split: true,
                "max-length": 255,
              },
              model: {
                value: _vm.value.salary,
                callback: function ($$v) {
                  _vm.$set(_vm.value, "salary", $$v)
                },
                expression: "value.salary",
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "col col-1 col-md-2 remove d-none d-md-block d-xl-none",
        },
        [
          _vm.canRemove
            ? _c("c-button", {
                directives: [
                  {
                    name: "b-popover",
                    rawName: "v-b-popover.html",
                    value: {
                      container: "#app",
                      trigger: "hover blur",
                      content: "Удалить",
                      placement: "top",
                    },
                    expression:
                      "{\n          container: '#app',\n          trigger: 'hover blur',\n          content: 'Удалить',\n          placement: 'top',\n        }",
                    modifiers: { html: true },
                  },
                ],
                attrs: { size: "iconic", icon: "trash" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("remove")
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("div", { staticClass: "col col-12 col-md-3 period" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("month-period-select", {
              attrs: {
                "floating-label": "Начало — окончание работы",
                clearable: true,
                invalid: !!(_vm.error && _vm.error.period),
                error: _vm.error && _vm.error.period,
              },
              model: {
                value: _vm.value.period,
                callback: function ($$v) {
                  _vm.$set(_vm.value, "period", $$v)
                },
                expression: "value.period",
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "col col-1 remove d-none d-xl-block" },
        [
          _vm.canRemove
            ? _c("c-button", {
                directives: [
                  {
                    name: "b-popover",
                    rawName: "v-b-popover.html",
                    value: {
                      container: "#app",
                      trigger: "hover blur",
                      content: "Удалить",
                      placement: "top",
                    },
                    expression:
                      "{\n          container: '#app',\n          trigger: 'hover blur',\n          content: 'Удалить',\n          placement: 'top',\n        }",
                    modifiers: { html: true },
                  },
                ],
                attrs: { size: "iconic", icon: "trash" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("remove")
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("div", { staticClass: "col col-12 col-md-6 recommender" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("c-input", {
              attrs: {
                "floating-label": "Кто может вас рекомендовать",
                clearable: true,
                "max-length": 255,
              },
              model: {
                value: _vm.value.recommender,
                callback: function ($$v) {
                  _vm.$set(_vm.value, "recommender", $$v)
                },
                expression: "value.recommender",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "col col-12 col-md-3 contact" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("c-input", {
              attrs: {
                "floating-label": "Телефон или email",
                clearable: true,
                "max-length": 255,
              },
              model: {
                value: _vm.value.contact,
                callback: function ($$v) {
                  _vm.$set(_vm.value, "contact", $$v)
                },
                expression: "value.contact",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "col col-12 d-md-none" }, [
        _c(
          "div",
          { staticClass: "d-flex justify-content-end" },
          [
            _vm.canRemove
              ? _c("c-button", {
                  directives: [
                    {
                      name: "b-popover",
                      rawName: "v-b-popover.html",
                      value: {
                        container: "#app",
                        trigger: "hover blur",
                        content: "Удалить",
                        placement: "top",
                      },
                      expression:
                        "{\n            container: '#app',\n            trigger: 'hover blur',\n            content: 'Удалить',\n            placement: 'top',\n          }",
                      modifiers: { html: true },
                    },
                  ],
                  attrs: { size: "small", label: "Удалить", icon: "trash" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("remove")
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }